import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import LTRCommonActionPanel from '../../shared/domains/LTRCommonActionPanel'

import QuickAddSubscription from './QuickAddSubscription';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import {SubscriptionType} from '../../../Enums';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  }
}));

const SubscriptionActionPanel = (props) => {
  const classes = useStyles();

  const [subscriptionType, setSubscriptionType] = useState(SubscriptionType.Other)
  const [quickAddOpen, setQuickAddOpen] = useState(false);

  const handleAddSubscription = (type) => {
    setSubscriptionType(type)
    setQuickAddOpen(true);

  }
  
  const handleCloseQuickAddOpen = () => {
    setQuickAddOpen(false);
  }

  const handleSave  = (subscription) => {
    props.handleAddNotification(subscription);
  }

  const handleReceiveData = (data) => {
    if (props.handleReceiveData) {
      props.handleReceiveData(data);
    }
  }

  return (
    <div className={classes.root}>
      <LTRCommonActionPanel
        actionComponents = {
          <ButtonGroup
            orientation="vertical"
            size = "small"
            color="primary"
            variant="text"
            aria-label="vertical outlined primary button group"
            >
            <Button className={classes.button} onClick={() => handleAddSubscription(SubscriptionType.Software)} color="primary">
              Add an software service subscription
            </Button>
            <Button className={classes.button} onClick={() => handleAddSubscription(SubscriptionType.Newspaper)}   color="primary">
              Add a newspaper subscription 
            </Button>
            <Button className={classes.button} onClick={() => handleAddSubscription(SubscriptionType.Magazine)}   color="primary">
              Add a magazine subscription 
            </Button>
            <Button className={classes.button} onClick={() => handleAddSubscription(SubscriptionType.Music)}   color="primary">
              Add a music subscription 
            </Button>
            <Button className={classes.button} onClick={() => handleAddSubscription(SubscriptionType.Video)}   color="primary">
              Add a video subscription 
            </Button>
          </ButtonGroup>
        }
        />
        {quickAddOpen ? (
           <QuickAddSubscription 
              open = {quickAddOpen}
              subscriptionType = {subscriptionType}
              handleClose = {handleCloseQuickAddOpen}
              handleSave = {handleSave}
              handleReceiveData = {handleReceiveData}
           />) 
          : null
        }
    
    </div>
  )
}

SubscriptionActionPanel.propTypes = {
  handleAddNotification: PropTypes.func.isRequired,
  handleReceiveData:PropTypes.func
}

export default (SubscriptionActionPanel)
